import React from 'react';

export const NavBar = () => {
    return <div className='nav'>
        <span style={{ paddingRight: 6 }}>MURPH</span>
        <img src="logo512.png" alt="logo" width="35" />
    </div>
}